module.exports = __webpack_public_path__ + "static/media/logo-esrb-t.9297273f.png";